export class ConfiguracoesAluguel {
    finalidade: string;
    tipo: string;
    local: string;
    motivo: string;
    dataAquisicao: string;
    dataAdmissao: string;
    nacionalidade: string;
    ocupacao: string;
    residente: string;
    conjugeNome: string;
    conjugeCpf: string;
    assist24hs: string;
    aluguel: number;
    iptu: number;
    agua: number;
    luz: number;
    gas: number;
    condominio: number;
    danoImovel: boolean;
    pinturaInterna: boolean;
    pinturaExterna: boolean;
    multaContratual: boolean;
    dataFundacao: string;
    faturamentoMensal: number;
    regimeTributario: string;
    cnae: string;
    rendaMensal: number;

    constructor() {
        this.finalidade = null;
        this.tipo = null;
        this.local = null;
        this.motivo = null;
        this.dataAquisicao = null;
        this.dataAdmissao = null;
        this.nacionalidade = null;
        this.ocupacao = null;
        this.residente = null;
        this.conjugeNome = null;
        this.conjugeCpf = null;
        this.assist24hs = null;
        this.aluguel = null;
        this.iptu = null;
        this.agua = null;
        this.luz = null;
        this.gas = null;
        this.condominio = null;
        this.danoImovel = null;
        this.pinturaInterna = null;
        this.pinturaInterna = null;
        this.multaContratual = null;
        this.dataFundacao = null;
        this.faturamentoMensal = null;
        this.regimeTributario = null;
        this.cnae = null;
        this.rendaMensal = null;
    }
}